var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from 'react';
import { LiTag, SpanTag, ITag } from '../../Utils/AtomicTag';
import { timelineItemProps } from './defaults';
var TimelineItem = /** @class */ (function (_super) {
    __extends(TimelineItem, _super);
    function TimelineItem(props) {
        return _super.call(this, props) || this;
    }
    TimelineItem.prototype.render = function () {
        var _a = this.props, color = _a.color, label = _a.label, children = _a.children, className = _a.className, style = _a.style, dot = _a.dot, align = _a.align;
        var itemClass = ['relative', 'pl-px-32', 'pr-px-32', 'pb-px-10', 'text-sm'];
        var timeClass = ['relative'];
        var contentClass = [
            'relative',
            'overflow-hidden',
            'w-full',
            'break-word',
            'break-all',
        ];
        var lineClass = [
            'absolute',
            'left-0',
            'top-0',
            'h-full',
            'border-solid',
            'border-gray-200',
            'border-l-2',
        ];
        var dotClass = [
            'absolute',
            'top-0',
            'w-px-10',
            'h-px-10',
            'rounded-lg',
            'z-10',
            'border-2',
            'border-solid',
        ];
        var customerDotClass = ['absolute', 'bg-white', 'left-0'];
        if (align === 'right') {
            itemClass.push('text-right');
            timeClass.push('float-right', 'ml-px-8', 'mr-0');
            lineClass.push('right-0', 'left-auto');
            dotClass.push('left-auto');
        }
        else if (align === 'center') {
            itemClass.push('w-1/2');
            timeClass.push('mr-px-8');
        }
        else {
            timeClass.push('mr-px-8');
        }
        if (color === 'blue') {
            contentClass.push('text-brand-600');
            dotClass.push('bg-brand-600');
        }
        else if (color === 'red') {
            contentClass.push('text-error-900');
            dotClass.push('bg-error-900');
        }
        else if (color === 'green') {
            contentClass.push('text-succ-900');
            dotClass.push('bg-succ-900');
        }
        else {
            contentClass.push('text-gray-700');
            dotClass.push('bg-white');
        }
        return (React.createElement(LiTag, { atomics: itemClass, autoPrefixedClassName: "timeline-item", className: (className || '') + " " + (color ? "is-" + color : ''), style: style },
            label && (React.createElement(SpanTag, { atomics: timeClass, autoPrefixedClassName: "timeline-time" }, label)),
            React.createElement(SpanTag, { atomics: contentClass, autoPrefixedClassName: "timeline-content" }, children),
            React.createElement(ITag, { atomics: lineClass, autoPrefixedClassName: "timeline-line" }),
            dot ? (React.createElement(SpanTag, { atomics: customerDotClass }, dot)) : (React.createElement(ITag, { atomics: dotClass, autoPrefixedClassName: "timeline-dot" }))));
    };
    TimelineItem.defaultProps = timelineItemProps;
    return TimelineItem;
}(PureComponent));
export { TimelineItem };
